import bodyContentType from 'owa-service/lib/factory/bodyContentType';
import EventScope from 'owa-service/lib/contract/EventScope';
import getItemIdToUpdate from '../utils/getItemIdToUpdate';
import respondToCalendarEventOperation from 'owa-service/lib/operation/respondToCalendarEventOperation';
import respondToCalendarEventRequest from 'owa-service/lib/factory/respondToCalendarEventRequest';
import ResponseTypeType from 'owa-service/lib/contract/ResponseTypeType';
import { ClientItemId } from 'owa-client-ids';
import { getEwsRequestString } from 'owa-datetime';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { OwaDate } from 'owa-datetime';
import getMailboxRequestOptions from 'owa-service-utils/lib/getMailboxRequestOptions';

/**
 * Service which invokes sending of an email response to an event
 * @param itemId
 * @param response
 * @param eventScope
 * @param sendResponse
 * @param responseNotes
 * @param proposedStartTime
 * @param proposedEndTime
 * @param MeetingRequestIdToBeDeleted
 */
export const respondToCalendarEventService = async (
    { Id, mailboxInfo }: ClientItemId,
    response: ResponseTypeType,
    eventScope?: EventScope,
    sendResponse?: boolean,
    responseNotes?: string,
    proposedStartTime?: OwaDate,
    proposedEndTime?: OwaDate,
    meetingRequestIdToBeDeleted?: string
) => {
    const operationResponse = await respondToCalendarEventOperation(
        {
            Header: getJsonRequestHeader(),
            Body: respondToCalendarEventRequest({
                EventId: getItemIdToUpdate(Id, eventScope),
                Response: response,
                SendResponse: sendResponse,
                Notes: bodyContentType({
                    BodyType: 'HTML',
                    Value: responseNotes,
                }),
                ProposedStartTime: proposedStartTime ? getEwsRequestString(proposedStartTime) : '',
                ProposedEndTime: proposedEndTime ? getEwsRequestString(proposedEndTime) : '',
                MeetingRequestIdToBeDeleted: meetingRequestIdToBeDeleted,
            }),
        },
        getMailboxRequestOptions(mailboxInfo)
    );

    return operationResponse?.Body;
};
